// CJS `exports.default = class` double-wraps under Vite ESM interop
import SnackbarModule from "awesome-snackbar";

import { Routes, StorageKey } from "@ctypes";
import { Translations, i18n } from "@i18n";
import { SessionReplay } from "@services";
import {
  DEFAULT_PREFILL_PROPS,
  useApplicationStore,
  useGoalStore,
  usePrefillStore,
  useThemeStore,
} from "@stores";
import { JwtPayload, jwtDecode } from "jwt-decode";
import { clearDeeplinkPromoCode } from "./promo";

const Snackbar = (SnackbarModule as any).default ?? SnackbarModule;

export const isTokenExpired = (token: string) => {
  try {
    const { exp } = jwtDecode<JwtPayload>(token);

    if (!exp) return true;

    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

export const handleTokenExpiration = () => {
  useApplicationStore.getState().setApplicationProps({ tokenExpired: true });
  clearSessionFromStorage();

  new Snackbar(`<p class="errorBanner">${i18n.t(Translations.AuthExpirationMessage)}</p>`, {
    position: "bottom-center",
    timeout: 5000,
    style: {
      container: [["background-color", useThemeStore.getState().theme.infoBanner.background]],
    },
    afterHide: () => {
      window.location.href = Routes.Auth;
    },
  });
};

export const clearSessionFromStorage = () => {
  // Clears the Mixpanel distinct_id along with the rest of the session, so the
  // next replay on this browser is not stitched onto the account signing out.
  SessionReplay.reset();

  localStorage.removeItem(StorageKey.Token);
  localStorage.removeItem(StorageKey.User);
  localStorage.removeItem(StorageKey.FeatureFlags);
  localStorage.removeItem(StorageKey.AnonymousId);

  useGoalStore.getState().setGoalProps({});
  usePrefillStore.getState().setPrefillProps(DEFAULT_PREFILL_PROPS);
  sessionStorage.removeItem(StorageKey.OnboardingFlowState);

  // A promo code from a deeplink outlives a single tab so an interrupted signup can resume, so it
  // has to be dropped here or it would attach to whoever signs up next on this browser.
  clearDeeplinkPromoCode();
};
